import React, { useEffect, useState } from 'react';
import { useWorkOrderLinkOptions } from '../../hooks/useWorkOrders';
import { ENABLE_WORK_ORDERS } from '../../config/featureFlags';
import AppSelect, { APP_SELECT_FILTER_TRIGGER } from '../shared/AppSelect';

export default function WorkOrderLinkSelect(props) {
  if (!ENABLE_WORK_ORDERS) return null;
  return <WorkOrderLinkSelectInner {...props} />;
}

function WorkOrderLinkSelectInner({
  db,
  companyCtx,
  workOrderId = '',
  phaseId = '',
  costCategory = '',
  onChange,
  disabled = false,
  className = '',
}) {
  const COST_CATEGORIES = ['', 'material', 'labour', 'subcontract', 'transport', 'equipment', 'overhead', 'other'];
  const { workOrders, woLoading, loadPhases } = useWorkOrderLinkOptions(db, companyCtx);
  const [phases, setPhases] = useState([]);
  const [phasesLoading, setPhasesLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!workOrderId) {
      setPhases([]);
      return undefined;
    }
    setPhasesLoading(true);
    loadPhases(workOrderId).then((rows) => {
      if (!cancelled) {
        setPhases(rows);
        setPhasesLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, [workOrderId, loadPhases]);

  const emit = (patch) => {
    onChange?.({
      workOrderId: patch.workOrderId !== undefined ? patch.workOrderId : workOrderId,
      phaseId: patch.phaseId !== undefined ? patch.phaseId : phaseId,
      costCategory: patch.costCategory !== undefined ? patch.costCategory : costCategory,
    });
  };

  const trigger = `${APP_SELECT_FILTER_TRIGGER} rounded-md`;

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-3 gap-3 ${className}`}>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Work Order (optional)</label>
        <AppSelect
          value={workOrderId}
          onChange={(e) => emit({ workOrderId: e.target.value, phaseId: '' })}
          disabled={disabled || woLoading}
          placeholder="— None —"
          aria-label="Work order"
          sheetTitle="Work order"
          options={[
            { value: '', label: '— None —' },
            ...workOrders.map((wo) => ({
              value: wo.id,
              label: `${wo.workOrderNo || wo.id} — ${wo.title || 'Untitled'}`,
            })),
          ]}
          triggerClassName={trigger}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Phase (optional)</label>
        <AppSelect
          value={phaseId}
          onChange={(e) => emit({ phaseId: e.target.value })}
          disabled={disabled || !workOrderId || phasesLoading}
          placeholder="— None —"
          aria-label="Phase"
          sheetTitle="Phase"
          options={[
            { value: '', label: '— None —' },
            ...phases.map((p) => ({ value: p.id, label: p.name })),
          ]}
          triggerClassName={trigger}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Cost category</label>
        <AppSelect
          value={costCategory}
          onChange={(e) => emit({ costCategory: e.target.value })}
          disabled={disabled}
          aria-label="Cost category"
          sheetTitle="Cost category"
          options={COST_CATEGORIES.map((c) => ({
            value: c,
            label: c ? c.charAt(0).toUpperCase() + c.slice(1) : '— None —',
          }))}
          triggerClassName={trigger}
        />
      </div>
    </div>
  );
}
